import { useAtom } from "jotai"
import { getPlayerThickIcon } from "app/player/getPlayerThickIcon"
import { isLoopEnabledAtom } from "app/player/state"
import { ComponentProps } from "react"
import PlayerIcon from "./PlayerIcon"
import PlayerIconButton from "./PlayerIconButton"

type Props = {
  size?: ComponentProps<typeof PlayerIconButton>["size"]
  color?: ComponentProps<typeof PlayerIconButton>["color"]
}

export default function PlayerLoopButton({ size, color = "blue" }: Props) {
  const [enabled, setLoopEnabled] = useAtom(isLoopEnabledAtom)

  return (
    <PlayerIconButton
      size={size}
      color={color}
      toggled={enabled}
      onClick={() => setLoopEnabled((prevState) => !prevState)}
      aria-label="Repeat"
      aria-pressed={enabled}
    >
      <PlayerIcon
        src={
          enabled
            ? "/icons/player/thick/ico_repeat_active.svg"
            : getPlayerThickIcon(color, "ico_repeat.svg")
        }
        size={18}
      />
    </PlayerIconButton>
  )
}
